import { useSelector } from "react-redux";
import DebugCheck from "./DailyCheck";
import { selectDailyGoals } from "src/selectors/dailiesSelectors";
import Goal from "src/models/Goal";
import { removeUserContributions, addUserContributions } from "src/store/dailies";
import Contribution from 'src/models/Contribution';
import { RootState, useAppDispatch } from "src/store";
import styles from './DailyCheck.module.css';
import { useRef, useState } from "react";
import { getGoals, updateDailies } from "src/thunks/goalThunks";
import { firstContributionForToday } from "src/helpers";
import DailyLoader from "./DailyLoader";
import { useEffect } from "react";


// Define component
function DailyDash() {

  const dailyGoals = useSelector(selectDailyGoals);
  const dispatch = useAppDispatch();
  const loading = useSelector((state: RootState) => state.dailies.status);

  //put a local state here for the temporary success message after loading data.
  const [showsuccessMessage, setShowSuccessMessage] = useState(false);
  useEffect(() => {
    dispatch(getGoals());
     
  }, []);
  //whenever loading is changed, this will run.
  useEffect(() => {

    if (loading == "succeeded") {
      setShowSuccessMessage(true);
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 2000);
    }
  }, [loading]);

  type TimerRef = ReturnType<typeof setTimeout>;
  const inactiveToggleTimerRef = useRef<TimerRef | null>(null);

  const stopTimer = () => {
    if (inactiveToggleTimerRef.current) {
      clearTimeout(inactiveToggleTimerRef.current);
    }
  }

  const handleTryFetchGoal = () => {
    dispatch(getGoals());
  }

  const handleToggleGoal = (g: Goal) => {
    let todaysContribution = firstContributionForToday(g);

    if (todaysContribution !== undefined) {

      dispatch(removeUserContributions({ contributionsToRemove: [todaysContribution], goalId: g.id }));

    } else {
      const today = new Date();
      todaysContribution = new Contribution("lione", 5, today);
      dispatch(addUserContributions({ contributionsToAdd: [todaysContribution.toPOJO()], goalId: g.id }));

    }

    stopTimer();
    inactiveToggleTimerRef.current = setTimeout(() => {
      dispatch(updateDailies());
    }, 1500);
  }


  const isDone = loading === 'succeeded';
  const isLoading = loading === 'loading';
  return (
    <>

      
      {loading === 'failed' && <>
      <p>FAILED</p>
      <button onClick={handleTryFetchGoal}>try again</button>
      </>}
      {showsuccessMessage && <p>WOWWOOWOWO</p>}
      loadddd {loading}
      {(isLoading || (showsuccessMessage && isDone)) &&
      <div className={styles.row} >
        {/* <DailyLoader done={isDone}/> */}
      </div>
}
{!showsuccessMessage && loading === 'succeeded' && <p>show things here</p>}

      

      <div style={{ backgroundColor: 'darkgrey', justifyContent: "center" }}>
        <div className={styles.dailiesBorder}>
        
          {loading === 'loading' ? <div style={{}}> 
          {/* <DailyLoader done={isDone} />  */}
          </div>:
            loading === 'succeeded' ? <div className={`${styles['fade-in-section']} ${loading === 'succeeded' ? styles.visible : ''}`}>
            </div>
          
            :<></>
          }
          <div className={styles.dailiesBackground}  >
          {dailyGoals.map(g => <div key={g.id} className={styles.dailiesItem}><DebugCheck key={g.id} ontoggle={handleToggleGoal} goal={g} isChecked={!!firstContributionForToday(g)} /></div>)}
          </div>
        </div >
      </div>
    </>
  );
};

export default DailyDash;